import useMediaQuery from "./useMediaQuery";

const useIsScreenXXS = () => {
  return useMediaQuery("(max-width: 430px)");
};

export default useIsScreenXXS;
